module.exports = __webpack_public_path__ + "img/2.edb4898a.jpg";